import { render, staticRenderFns } from "./CapacitorTable.vue?vue&type=template&id=794285e6"
import script from "./CapacitorTable.vue?vue&type=script&lang=ts"
export * from "./CapacitorTable.vue?vue&type=script&lang=ts"
import style0 from "./CapacitorTable.vue?vue&type=style&index=0&id=794285e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports